import InitialCohort from '../../constants/initial-cohort';
import TargetCohort from '../../constants/target-cohort';

class ParamStore extends EventEmitter {
    constructor() {
        super();

        this.CHANGE_EVENT = 'PARAM_CHANGE_EVENT';

        this._model = {};
    }

    registerComponent(componentId) {
        this._model[`c${componentId}`] = {
            instanceId: 'unknown-jwf-login-implementer',

            rootUrl: '/',
            initialCohort: InitialCohort.singlePasswordRegistration,
            targetCohort: TargetCohort.loggedInStartTab,

            clsEndpoint: '',
            clsClientId: '',
            clsReturnUrl: '',
            clsLoginUrl: '',
            clsAutoLoginReturnUrl: '',
            websiteEndpoint: '',
            disableRedirectToLogin: false,
            disableKeepLoggedInCheckbox: false,

            targetUrl: null,
            clsExecutionArea: 'cls-execution-area',

            sentryUrl: '',
            userLogData: {
                anonymousId: '',
                lang: '',
                phasedRolloutChannel: '',
                userVariations: ''
            },

            lang5: 'en-US',
            callbacks: {
                successfulRegistrationAtClsSide: null,
                successfulLoginAtClsSide: null,
                successfulRegistrationAtHtml5Side: null,
                registration: null,
            },

            tracking: {
                segment: {
                    containerProperty: 'unknown-jwf-login-implementer',
                    registrationSource: 'unknown-jwf-login-implementer',
                    loginSource: 'unknown-jwf-login-implementer',
                },
                ga: {}
            },

            silentMode: false
        };
    }

    getModel(componentId) {
        if (componentId === undefined || componentId === null) {
            throw new Error('componentId is missing');
        }

        return this._model[`c${componentId}`];
    }

    addChangeListener(callback) {
        this.on(this.CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(this.CHANGE_EVENT, callback);
    }

    update(componentId, updateFn) {
        if (updateFn) {
            updateFn(this.getModel(componentId));
        }

        this.emit(this.CHANGE_EVENT);
    }
}

let paramStore = new ParamStore();
paramStore.setMaxListeners(1000000);
export default paramStore;



/** WEBPACK FOOTER **
 ** ./src/logic/stores/param-store.js
 **/